import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import queryString from 'query-string';

import type {
  GiftCard,
  GiftCardDetails,
  GiftCardListParams,
} from 'app/typings/giftCard';
import { apiRequest } from 'app/utils/request/api';

const path = '/admin/gift-cards' as const;

export const pathDetails = '/gateway/admin/gift-cards/:code' as const;

export function useGetGiftCards(giftCardListParams: GiftCardListParams) {
  const stringifiedParams = queryString.stringify(giftCardListParams);

  return useQuery({
    queryKey: [path, { stringifiedParams }],
    queryFn: () =>
      apiRequest({ path: `${path}?${stringifiedParams}` }) as Promise<
        GiftCard[]
      >,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    placeholderData: keepPreviousData,
  });
}

export function useGiftCardDetails(code: string) {
  return useQuery({
    queryKey: [pathDetails, { code }],
    queryFn: () =>
      apiRequest({
        path: pathDetails,
        params: { code },
      }) as Promise<GiftCardDetails>,
    staleTime: Infinity,
  });
}
